import './App.css'
import { QuoteProvider, useQuote } from './contexts/QuoteContext'
import Step1ProductType from './components/steps/Step1ProductType'
import Step2ChooseModel from './components/steps/Step2ChooseModel'
import Step3ModelVariant from './components/steps/Step3ModelVariant'
import Step4Upgrades from './components/steps/Step4Upgrades'
import Step5Color from './components/steps/Step5Color'
import Step6DeliveryLocation from './components/steps/Step6DeliveryLocation'
import QuoteSidebar from './components/QuoteSidebar'

const AppContent = () => {
  const { quoteState } = useQuote();

  // Determine step states based on selections
  const step1Completed = !!quoteState.selectedProduct;
  const step1Active = !step1Completed;
  const step1Disabled = false; // First step is never disabled

  const step2Completed = step1Completed && !!quoteState.selectedModel;
  const step2Active = step1Completed && !step2Completed;
  const step2Disabled = !step1Completed; // Disabled until step 1 is completed

  const step3Completed = step2Completed && !!quoteState.selectedVariant;
  const step3Active = step2Completed && !step3Completed;
  const step3Disabled = !step2Completed; // Disabled until step 2 is completed

  const step4Completed = step3Completed && quoteState.selectedUpgrades.length > 0; // Only completed when upgrades are selected
  const step4Active = step3Completed && !step4Completed;
  const step4Disabled = !step3Completed; // Disabled until step 3 is completed

  const step5Completed = step3Completed && !!quoteState.selectedColor;
  const step5Active = step3Completed && !step5Completed;
  const step5Disabled = !step3Completed; // Disabled until step 3 is completed

  const step6Completed = step5Completed && !!quoteState.selectedDeliveryLocation;
  const step6Active = step5Completed && !step6Completed;
  const step6Disabled = !step5Completed; // Disabled until step 5 is completed

  return (
    <div className="app-container">
      {/* Header */}
      <div className="header">
        <div className="header-content">
          <div className="header-text">
            <h1 className="header-title">Custom Quote Builder</h1>
            <p className="header-subtitle">Configure your camper or trailer</p>
          </div>
          <a href="https://tufftrack.com.au/" className="close-button" style={{display: 'flex', alignItems: 'center', gap: '8px', textDecoration: 'none', color: 'white'}}>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.5 13.5L6 9L10.5 4.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span>Back to tufftrack.com.au</span>
          </a>
        </div>
      </div>

      {/* Main Content */}
      <div className="main-content">
        {/* Left Content */}
        <div className="left-content">
          <Step1ProductType isActive={step1Active} isCompleted={step1Completed} isDisabled={step1Disabled} />
          <div className="step-divider"></div>

          <Step2ChooseModel isActive={step2Active} isCompleted={step2Completed} isDisabled={step2Disabled} />
          <div className="step-divider"></div>

          <Step3ModelVariant isActive={step3Active} isCompleted={step3Completed} isDisabled={step3Disabled} />
          <div className="step-divider"></div>

          <Step4Upgrades isActive={step4Active} isCompleted={step4Completed} isDisabled={step4Disabled} />
          <div className="step-divider"></div>

          <Step5Color isActive={step5Active} isCompleted={step5Completed} isDisabled={step5Disabled} />
          <div className="step-divider"></div>

          <Step6DeliveryLocation isActive={step6Active} isCompleted={step6Completed} isDisabled={step6Disabled} />
        </div>

        {/* Right Sidebar */}
        <QuoteSidebar />
      </div>
    </div>
  );
};

function App() {
  return (
    <QuoteProvider>
      <AppContent />
    </QuoteProvider>
  )
}

export default App
